import { HttpClient } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'sl16',
  templateUrl: './sl16.component.html',
  styleUrls: ['./sl16.component.scss']
})
export class SL16Component {
  @Input() package: any;

  company = environment.company;
  isAnitia: boolean = false;

  constructor(
    private translate: TranslateService,
    private http: HttpClient,
    private router: Router
  ) {
    
  }
 
  ngOnInit(): void {
    if(this.company == 'anitia'){
      this.isAnitia = true;
    }
  }

  protected buttonClick(link: string): void {
    this.router.navigate([link]);
  }
}
